<template>
  <div class="act-card-box">
    <div class="act-card-img">
      <img class="lazy-img" :class="{ imgError }" :data-src="imgUrlPrefix + cardObj.img" :alt="cardObj.name" @error="handleImgError" />
      <div class="card-fallback" v-if="imgError"><span>IMAGE</span></div>
    </div>
    <div class="act-card-user">
      <div class="card-avatar">
        <img :src="userHeadPrefix + cardObj.avatarImg" :alt="cardObj.avatarName" />
      </div>
      <span class="card-username">{{ cardObj.avatarName }}</span>
    </div>
    <div class="act-card-title">{{ cardObj.name }}</div>
  </div>
</template>

<script>
import { imgLazyLoad, destroyImgLazyLoad } from '../../utils/imgLazyLoad'
export default {
  name: 'ActCard',
  props: {
    cardObj: {
      type: Object,
      required: true
    },
    imgUrlPrefix: {
      type: String,
      required: true
    },
    userHeadPrefix: {
      type: String,
      required: true
    }
  },
  mounted() {
    imgLazyLoad();
  },
  beforeDestroy() {
    destroyImgLazyLoad();
  },
  data() {
    return {
      imgError: false
    }
  },
  methods: {
    handleImgError() {
      this.imgError = true;
    }
  }
}
</script>

<style lang="less" scoped>
.act-card-box {
  .act-card-img {
    height: 200px;
    overflow: hidden;
    background: #e8e8e8;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .card-fallback {
      display: flex;
      position: absolute;
      inset: 0;
      background: @img-bg;
      align-items: center;
      justify-content: center;
      span {
        font-size:9px;letter-spacing:2px;color:rgba(0,0,0,0.2);text-transform:uppercase;
      }
    }
    img.imgError {
      display: none;
    }
  }
  .act-card-user {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 12px 0 6px;
    .card-avatar {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: @bdr;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;

      }
    }
    .card-username {
      font-size: 10px;
      letter-spacing: 1px;
      color: @mute;
      font-family: 'Roboto Mono', monospace;
      font-weight: 300;
    }
  }
  .act-card-title {
    font-size: 13px;
    font-weight: 300;
    color: var(--ink);
  }
}
</style>